import styles from './Divider.module.css';

export function Divider() {
  return <li className={styles.divider} />;
}
